import * as React from "react";
import { InputAdornment, TextFieldProps } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { useHubx, useHubXSubscribe } from "../../../HubX";
import uuidv4 from "../../../helpers/uuid";
import { EVENT_SEARCH_FIELD_CHANGE, EVENT_SEARCH_FIELD_EXTERNAL_CHANGE } from "../../../Events";
import SimpleTextField from "../../../components/SimpleTextField";

type SearchFieldProps = {
  eventId?: string;
  useCustomEvent?: boolean;
  notifyOnExternalUpdate?: boolean;
} & Omit<TextFieldProps, "value">;

function SearchField({
  eventId,
  useCustomEvent = false,
  notifyOnExternalUpdate = false,
  ...others
}: SearchFieldProps) {
  const [value, setValue] = React.useState<string>("");
  const hub = useHubx();

  const useId = eventId || uuidv4();

  const doNotify = (message: string) => {
    hub.notify(useCustomEvent && eventId ? eventId : EVENT_SEARCH_FIELD_CHANGE(useId), message);
  };

  const handleChange = (e: React.ChangeEvent<{ value: string }>) => {
    const newValue = e.target.value;
    setValue(newValue);
    doNotify(newValue);
  };

  const doUpdateFromExternal = (newValue: string) => {
    setValue(newValue);

    if (notifyOnExternalUpdate) {
      doNotify(newValue);
    }
  };

  useHubXSubscribe(EVENT_SEARCH_FIELD_EXTERNAL_CHANGE(useId), doUpdateFromExternal);

  return (
    <SimpleTextField
      autoComplete="off"
      value={value}
      onChange={handleChange}
      label="Buscar"
      id="filterSearch"
      variant="outlined"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
      {...others}
    />
  );
}

export default SearchField;
